import { useState } from 'react';
import { TrendingUp, Mail, MessageCircle, Instagram, Twitter, ChevronRight, ExternalLink, X } from 'lucide-react';

type ModalType = 'terms' | 'privacy' | 'disclaimer' | 'contact' | null;

export const Footer = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const currentYear = new Date().getFullYear();

  const closeModal = () => setActiveModal(null);

  return (
    <>
      <footer className="bg-slate-900/50 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-xl flex items-center justify-center">
                  <TrendingUp className="w-5 h-5 text-white" />
                </div>
                <span className="text-xl font-bold text-white">GOTRADINGZY</span>
              </div>
              <p className="text-slate-400 text-sm mb-4 leading-relaxed">
                Platform trading dan analisis saham Indonesia terlengkap dengan screener canggih, chart real-time, dan sinyal trading profesional.
              </p>
              <div className="flex items-center space-x-3">
                <a href="https://t.me/bitzyid" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-slate-800 hover:bg-emerald-500/20 rounded-lg flex items-center justify-center text-slate-400 hover:text-emerald-400 transition-all">
                  <MessageCircle className="w-4 h-4" />
                </a>
                <a href="https://instagram.com/bitzy.id" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-slate-800 hover:bg-emerald-500/20 rounded-lg flex items-center justify-center text-slate-400 hover:text-emerald-400 transition-all">
                  <Instagram className="w-4 h-4" />
                </a>
                <a href="https://twitter.com/bitzy_id" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-slate-800 hover:bg-emerald-500/20 rounded-lg flex items-center justify-center text-slate-400 hover:text-emerald-400 transition-all">
                  <Twitter className="w-4 h-4" />
                </a>
                <a href="mailto:hello@bitzy.id" className="w-9 h-9 bg-slate-800 hover:bg-emerald-500/20 rounded-lg flex items-center justify-center text-slate-400 hover:text-emerald-400 transition-all">
                  <Mail className="w-4 h-4" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Fitur</h4>
              <ul className="space-y-2">
                {['Stock Screener', 'Analisis Teknikal', 'TradingView Chart', 'Portfolio Tracker', 'Watchlist', 'Sinyal Trading'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                      <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Screener</h4>
              <ul className="space-y-2">
                {['Top Broker Accum', 'Smart Money Flow', 'High Vol Breakout', 'Bullish Momentum', 'Net Foreign Buy', 'HAKA Screener'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                      <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                    <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    Syarat & Ketentuan
                  </button>
                </li>
                <li>
                  <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                    <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    Kebijakan Privasi
                  </button>
                </li>
                <li>
                  <button onClick={() => setActiveModal('disclaimer')} className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                    <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    Disclaimer
                  </button>
                </li>
                <li>
                  <button onClick={() => setActiveModal('contact')} className="text-slate-400 hover:text-emerald-400 text-sm flex items-center group transition-colors">
                    <ChevronRight className="w-3 h-3 mr-1 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    Hubungi Kami
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-slate-800">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-center space-x-2 text-slate-500 text-sm">
                <span>&copy; {currentYear}</span>
                <a href="https://bitzy.id" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 font-semibold flex items-center">
                  BITZY.ID
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
                <span>All rights reserved.</span>
              </div>
              <div className="flex items-center space-x-4 text-xs text-slate-600">
                <button onClick={() => setActiveModal('terms')} className="hover:text-slate-400 transition-colors">Terms</button>
                <span>|</span>
                <button onClick={() => setActiveModal('privacy')} className="hover:text-slate-400 transition-colors">Privacy</button>
                <span>|</span>
                <button onClick={() => setActiveModal('disclaimer')} className="hover:text-slate-400 transition-colors">Disclaimer</button>
              </div>
            </div>
            <p className="text-center text-xs text-slate-600 mt-4">
              Investasi saham mengandung risiko. Selalu lakukan riset Anda sendiri sebelum mengambil keputusan investasi.
            </p>
          </div>
        </div>
      </footer>

      {activeModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="bg-slate-900 border border-slate-800 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
            <div className="sticky top-0 bg-slate-900 border-b border-slate-800 px-6 py-4 flex items-center justify-between">
              <h2 className="text-xl font-bold text-white">
                {activeModal === 'terms' && 'Syarat & Ketentuan'}
                {activeModal === 'privacy' && 'Kebijakan Privasi'}
                {activeModal === 'disclaimer' && 'Disclaimer'}
                {activeModal === 'contact' && 'Hubungi Kami'}
              </h2>
              <button onClick={closeModal} className="p-2 hover:bg-slate-800 rounded-lg transition-colors">
                <X className="w-5 h-5 text-slate-400" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[60vh] prose prose-invert prose-sm">
              {activeModal === 'terms' && (
                <div className="space-y-4 text-slate-300">
                  <p className="text-slate-400 text-sm">Terakhir diperbarui: {currentYear}</p>
                  <h3 className="text-lg font-semibold text-white">1. Penerimaan Ketentuan</h3>
                  <p>Dengan mengakses dan menggunakan GOTRADINGZY, Anda setuju untuk terikat dengan syarat dan ketentuan ini. Jika Anda tidak setuju dengan ketentuan ini, mohon untuk tidak menggunakan layanan kami.</p>
                  <h3 className="text-lg font-semibold text-white">2. Deskripsi Layanan</h3>
                  <p>GOTRADINGZY menyediakan platform informasi dan analisis saham Indonesia. Layanan kami meliputi stock screener, analisis teknikal, chart trading, dan fitur portfolio tracking.</p>
                  <h3 className="text-lg font-semibold text-white">3. Penggunaan Layanan</h3>
                  <p>Anda setuju untuk menggunakan layanan ini hanya untuk tujuan yang sah dan sesuai dengan hukum yang berlaku di Indonesia. Dilarang keras untuk menyalahgunakan atau memanipulasi platform ini.</p>
                  <h3 className="text-lg font-semibold text-white">4. Akun Pengguna</h3>
                  <p>Anda bertanggung jawab untuk menjaga kerahasiaan akun dan password Anda. Segala aktivitas yang terjadi di akun Anda adalah tanggung jawab Anda sepenuhnya.</p>
                  <h3 className="text-lg font-semibold text-white">5. Hak Kekayaan Intelektual</h3>
                  <p>Semua konten, desain, logo, dan materi di GOTRADINGZY adalah milik BITZY.ID dan dilindungi oleh hukum hak cipta Indonesia.</p>
                  <h3 className="text-lg font-semibold text-white">6. Perubahan Ketentuan</h3>
                  <p>BITZY.ID berhak mengubah syarat dan ketentuan ini kapan saja. Perubahan akan berlaku segera setelah dipublikasikan di platform.</p>
                </div>
              )}

              {activeModal === 'privacy' && (
                <div className="space-y-4 text-slate-300">
                  <p className="text-slate-400 text-sm">Terakhir diperbarui: {currentYear}</p>
                  <h3 className="text-lg font-semibold text-white">1. Informasi yang Kami Kumpulkan</h3>
                  <p>Kami mengumpulkan informasi yang Anda berikan secara langsung, seperti nama, email, dan data akun Telegram untuk proses autentikasi.</p>
                  <h3 className="text-lg font-semibold text-white">2. Penggunaan Informasi</h3>
                  <p>Informasi yang dikumpulkan digunakan untuk:</p>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Menyediakan dan memelihara layanan</li>
                    <li>Mengirim notifikasi dan update penting</li>
                    <li>Meningkatkan pengalaman pengguna</li>
                    <li>Analisis dan pengembangan fitur</li>
                  </ul>
                  <h3 className="text-lg font-semibold text-white">3. Keamanan Data</h3>
                  <p>Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi data pribadi Anda dari akses tidak sah, perubahan, pengungkapan, atau penghancuran.</p>
                  <h3 className="text-lg font-semibold text-white">4. Berbagi Informasi</h3>
                  <p>Kami tidak menjual, memperdagangkan, atau mentransfer informasi pribadi Anda kepada pihak ketiga tanpa persetujuan Anda, kecuali diwajibkan oleh hukum.</p>
                  <h3 className="text-lg font-semibold text-white">5. Cookie dan Teknologi Pelacakan</h3>
                  <p>Kami menggunakan cookie untuk meningkatkan pengalaman pengguna dan menganalisis lalu lintas situs. Anda dapat mengatur browser untuk menolak cookie.</p>
                  <h3 className="text-lg font-semibold text-white">6. Hak Anda</h3>
                  <p>Anda berhak mengakses, memperbaiki, atau menghapus data pribadi Anda. Hubungi kami di hello@bitzy.id untuk permintaan terkait data.</p>
                </div>
              )}

              {activeModal === 'disclaimer' && (
                <div className="space-y-4 text-slate-300">
                  <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4 mb-4">
                    <p className="text-amber-400 font-semibold">Peringatan Risiko Investasi</p>
                  </div>
                  <h3 className="text-lg font-semibold text-white">1. Bukan Saran Investasi</h3>
                  <p>Semua informasi, analisis, dan data yang disajikan di GOTRADINGZY bersifat informatif dan edukatif. Ini BUKAN merupakan saran investasi, rekomendasi pembelian atau penjualan saham.</p>
                  <h3 className="text-lg font-semibold text-white">2. Risiko Investasi</h3>
                  <p>Investasi di pasar saham mengandung risiko tinggi, termasuk risiko kehilangan seluruh modal yang diinvestasikan. Kinerja masa lalu tidak menjamin hasil di masa depan.</p>
                  <h3 className="text-lg font-semibold text-white">3. Keputusan Investasi</h3>
                  <p>Keputusan investasi sepenuhnya merupakan tanggung jawab Anda sendiri. Selalu lakukan riset independen dan konsultasikan dengan penasihat keuangan berlisensi sebelum mengambil keputusan investasi.</p>
                  <h3 className="text-lg font-semibold text-white">4. Akurasi Data</h3>
                  <p>Meskipun kami berusaha menyajikan data yang akurat, kami tidak menjamin keakuratan, kelengkapan, atau ketepatan waktu dari semua informasi yang disajikan.</p>
                  <h3 className="text-lg font-semibold text-white">5. Batasan Tanggung Jawab</h3>
                  <p>BITZY.ID dan GOTRADINGZY tidak bertanggung jawab atas kerugian finansial yang mungkin timbul dari penggunaan informasi di platform ini.</p>
                </div>
              )}

              {activeModal === 'contact' && (
                <div className="space-y-4 text-slate-300">
                  <p>Kami senang mendengar dari Anda! Hubungi kami melalui salah satu channel berikut:</p>
                  <div className="grid gap-4">
                    <a href="mailto:hello@bitzy.id" className="flex items-center space-x-3 p-4 bg-slate-800 rounded-lg hover:bg-slate-700 transition-colors">
                      <div className="w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                        <Mail className="w-5 h-5 text-emerald-400" />
                      </div>
                      <div>
                        <div className="font-semibold text-white">Email</div>
                        <div className="text-sm text-slate-400">hello@bitzy.id</div>
                      </div>
                    </a>
                    <a href="https://t.me/bitzyid" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-4 bg-slate-800 rounded-lg hover:bg-slate-700 transition-colors">
                      <div className="w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                        <MessageCircle className="w-5 h-5 text-emerald-400" />
                      </div>
                      <div>
                        <div className="font-semibold text-white">Telegram</div>
                        <div className="text-sm text-slate-400">@bitzyid</div>
                      </div>
                    </a>
                    <a href="https://instagram.com/bitzy.id" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-4 bg-slate-800 rounded-lg hover:bg-slate-700 transition-colors">
                      <div className="w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                        <Instagram className="w-5 h-5 text-emerald-400" />
                      </div>
                      <div>
                        <div className="font-semibold text-white">Instagram</div>
                        <div className="text-sm text-slate-400">@bitzy.id</div>
                      </div>
                    </a>
                    <a href="https://twitter.com/bitzy_id" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-4 bg-slate-800 rounded-lg hover:bg-slate-700 transition-colors">
                      <div className="w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                        <Twitter className="w-5 h-5 text-emerald-400" />
                      </div>
                      <div>
                        <div className="font-semibold text-white">Twitter</div>
                        <div className="text-sm text-slate-400">@bitzy_id</div>
                      </div>
                    </a>
                  </div>
                  <p className="text-sm text-slate-500 mt-4">Jam operasional: Senin - Jumat, 09:00 - 17:00 WIB</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
